import {
    Breadcrumbs,
    BreadcrumbsLink,
    Container,
    Stack,
    Typography,
} from "@octopus-energy/coral/atoms"
import { type SbBlokData } from "@storyblok/react"
import { type StoryblokBreadCrumb } from "../../hooks/useStoryblokBreadcrumb"
import { StoryblokBlokLooper } from "../StoryblokBlokLooper"

type StoryblokFAQArticleProps = {
    crumbs: StoryblokBreadCrumb[]
    title: string
    blocks: SbBlokData[]
}

export function StoryblokFAQArticle({ blocks, crumbs, title }: StoryblokFAQArticleProps) {
    return (
        <article>
            <Stack flexDirection="column">
                <nav>
                    <Breadcrumbs>
                        {crumbs.map((crumb, index) => (
                            <BreadcrumbsLink
                                key={crumb.href}
                                href={crumb.href}
                                current={index === crumbs.length - 1}
                            >
                                {crumb.title}
                            </BreadcrumbsLink>
                        ))}
                    </Breadcrumbs>
                </nav>

                <Container
                    component="header"
                    marginBottom="md"
                >
                    <Typography
                        textAlign="center"
                        textStyle="h1"
                    >
                        {title}
                    </Typography>
                </Container>
            </Stack>
            <StoryblokBlokLooper
                required
                blocks={blocks}
            />
        </article>
    )
}
